import request from '@/utils/request'

let School_managementApi = {

  /*学校管理列表*/
  list(data) {
    return request._post('/shop/plus.school_management.Index/index', data);
},
/*添加学校管理*/
add(data) {
    return request._post('/shop/plus.school_management.Index/add', data);
},
/*修改学校管理*/
edit(data) {
    return request._post('/shop/plus.school_management.Index/edit', data);
},
/*删除学校管理*/
del(data) {
    return request._post('/shop/plus.school_management.Index/del', data);
},
/*学校管理详情*/
detail(data) {
  return request._post('/shop/plus.school_management.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.school_management.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.school_management.Setting/getSetting', data, errorback);
    },
}
export default School_managementApi;



// WEBPACK FOOTER //
// ./src/api/school_management.js